module.exports = __webpack_public_path__ + "img/img-3.d67754a5.png";